import { render, staticRenderFns } from "./WaMessageEdit.vue?vue&type=template&id=3b7e5e86&scoped=true&"
import script from "./WaMessageEdit.vue?vue&type=script&lang=js&"
export * from "./WaMessageEdit.vue?vue&type=script&lang=js&"
import style0 from "./WaMessageEdit.vue?vue&type=style&index=0&id=3b7e5e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e5e86",
  null
  
)

export default component.exports